// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"208a0a08","727":"269a238a"}[chunkId] + ".chunk.js";
};